import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import BusinessInformation from "../../../components/customer/customer-proofile/corporate-customer/BusinessInformation";
import PolicyInformation from "../../../components/customer/customer-proofile/individual-customer/PolicyInformation";
import PageTitle from "../../../components/partials/PageTitle";
import ContactInformation from "../../../components/customer/customer-proofile/corporate-customer/ContactInformation";
import Identification from "../../../components/customer/customer-proofile/corporate-customer/Identification";
import { useEffect, useState } from "react";
import {
  approveCustomer as approveCustomerFn,
  closeCustomer as closeCustomerFn,
  rejectCustomer as rejectCustomerFn,
} from "../../../redux/slice/customer/customerSlice";
import ModalContainer from "../../../components/modals/ModalContainer";
import ApproveCustomer from "../../../components/modals/customers/ApproveCustomer";
import RejectCustomer from "../../../components/modals/customers/RejectCustomer";
import CloseCustomer from "../../../components/modals/customers/CloseCustomer";
import ReactivateCustomer from "../../../components/modals/customers/ReactivateCustomer";

const CorporateCustomerProfile = ({ single_customer }) => {
  const [approveCustomer, setApproveCustomer] = useState();
  const [rejectCustomer, setRejectCustomer] = useState();
  const [closeCustomer, setCloseCustomer] = useState();

  const { state } = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();

  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const breadcrumb = {
    from: {
      title: "Corporate Customer",
      link: "/admin/corporate-customers",
    },
    current: {
      title: "Customer Profile",
      link: null,
    },
  };
  useEffect(() => {
    setApproveCustomer(
      user_permissions?.some(
        (permission) => permission.name === "approve customer"
      )
    );
    setRejectCustomer(
      user_permissions?.some(
        (permission) => permission.name === "reject customer"
      )
    );
    setCloseCustomer(
      user_permissions?.some(
        (permission) => permission.name === "close customer"
      )
    );
  }, [user_permissions]);
  return (
    <>
      {/* page title */}
      <PageTitle title='Customer Profile' breadcrumb={breadcrumb} />
      {/* end page title */}

      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            {/* {isLoading ? 
              <div className='d-flex mt-lg-5 justify-content-center align-content-center py-3'>
                <BounceLoader color='#2E3192' size={"70px"}/>
              </div> : */}
            <div className='card-body'>
              <BusinessInformation
                data={single_customer?.basic_information}
                data1={single_customer?.business_information}
              />
              <ContactInformation
                data={single_customer?.contact_information}
                data1={single_customer?.basic_information}
              />
              <Identification
                data={single_customer?.means_of_identification}
                data1={single_customer?.other_doc}
                data2={single_customer?.basic_information}
                data3={single_customer?.business_information}
              />
              {/* <PolicyInformation status = {single_customer?.basic_information?.status} /> */}
              <div className='row'>
                <div className='d-flex justify-content-end'>
                  {single_customer?.basic_information?.status === "1" && (
                    <div>
                      {approveCustomer && (
                        <button
                          type='button'
                          className={`btn btn-success btn-sm mt-3 px-4 text-white`}
                          data-bs-toggle='modal'
                          data-bs-target='#approve_customer'
                        >
                          Approve
                        </button>
                      )}
                      {rejectCustomer && (
                        <button
                          type='button'
                          className='btn btn-danger ms-2 btn-sm mt-3 px-4'
                          data-bs-toggle='modal'
                          data-bs-target='#reject_customer'
                        >
                          Reject
                        </button>
                      )}
                    </div>
                  )}
                  {single_customer?.basic_information?.status === "2" && (
                    <div>
                      {closeCustomer && (
                        <button
                          type='button'
                          className={`btn btn-danger btn-sm mt-3 px-4 text-white`}
                          data-bs-toggle='modal'
                          data-bs-target='#close_customer'
                        >
                          Close Customer
                        </button>
                      )}
                    </div>
                  )}

                  {single_customer?.basic_information?.status === "3" && (
                    <div>
                      {approveCustomer && (
                        <button
                          type='button'
                          className={`btn btn-success btn-sm mt-3 px-4 text-white`}
                          data-bs-toggle='modal'
                          data-bs-target='#reactivate_customer'
                        >
                          Reactivate
                        </button>
                      )}
                    </div>
                  )}
                  {single_customer?.basic_information?.status === "4" && (
                    <div>
                      {approveCustomer && (
                        <button
                          type='button'
                          className={`btn btn-success btn-sm mt-3 px-4 text-white`}
                          data-bs-toggle='modal'
                          data-bs-target='#reactivate_customer'
                        >
                          Reactivate
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* } */}
          </div>
        </div>
      </div>
      <ModalContainer
        modal_id='approve_customer'
        modal_width='modal-md'
        bradius='rounded-2'
      >
        <ApproveCustomer id={id} />
      </ModalContainer>
      <ModalContainer
        modal_id='reject_customer'
        modal_width='modal-md'
        bradius='rounded-2'
      >
        <RejectCustomer id={id} />
      </ModalContainer>
      <ModalContainer
        modal_id='close_customer'
        modal_width='modal-md'
        bradius='rounded-2'
      >
        <CloseCustomer id={id} />
      </ModalContainer>
      <ModalContainer
        modal_id='reactivate_customer'
        modal_width='modal-sm'
        bradius='rounded-2'
      >
        <ReactivateCustomer id={id} />
      </ModalContainer>
    </>
  );
};

export default CorporateCustomerProfile;
